import { tuiAsPopover } from '@taiga-ui/cdk/services';

import { ModalService } from './modal.service';

export const MODAL_PROVIDER = tuiAsPopover(ModalService);
